import {
  ITeamActivityParams,
  ITeamActivityResponse,
  ITeamActivityUserResponse,
} from 'shared';

import { orgHeader } from '../../../../common/lib/axiosBaseQuery';
import { emptySplitApi } from '../baseApi';

export type IFetchTeamActivityArgs = ITeamActivityParams & {
  organisationId: string;
};

export type IFetchTeamActivityUserArgs = IFetchTeamActivityArgs & {
  userId: string;
};

export const teamActivityApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchTeamActivity: builder.query<ITeamActivityResponse, IFetchTeamActivityArgs>({
      query: ({ organisationId, ...params }) => ({
        url: `team-activity`,
        method: `GET`,
        params,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
    }),
    fetchTeamActivityUser: builder.query<ITeamActivityUserResponse, IFetchTeamActivityUserArgs>({
      query: ({ organisationId, userId, ...params }) => ({
        url: `team-activity/users/${userId}`,
        method: `GET`,
        params,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
    }),
  }),
});

export const {
  useFetchTeamActivityQuery,
  useFetchTeamActivityUserQuery,
} = teamActivityApi;
